export default `
    precision highp float;

    varying vec3 vNormal;
    
    uniform vec3 uColor;
    uniform float uLight;

    void main() {
        vec3 normal = normalize(vNormal);
        float lighting = dot(normal, normalize(vec3(-0.3, 0.8, 0.6)));
        gl_FragColor.rgb = uColor + lighting * 0.1 * uLight;
        gl_FragColor.a = 1.0;
    }
`;
